import type { SVGProps } from "react";

export function IconPurplePcCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3335 51.3333L39.6668 51.3333"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 42.3333V6.66669C4.6665 5.56212 5.56194 4.66669 6.66651 4.66669H49.3332C50.4377 4.66669 51.3332 5.56212 51.3332 6.66669V42.3334C51.3332 43.4379 50.4377 44.3334 49.3332 44.3334H6.6665C5.56193 44.3334 4.6665 43.4379 4.6665 42.3333Z"
        stroke="#2E2E2E"
        strokeWidth="2"
      />
      <path
        d="M21 24.5L25.6667 29.1667L35 19.8333"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
